module.exports = __webpack_public_path__ + "img/step-help1.519b53fa.png";